import { render, staticRenderFns } from "./DialogExibeReleaseNotes.vue?vue&type=template&id=4a2c50c1"
import script from "./DialogExibeReleaseNotes.vue?vue&type=script&lang=js"
export * from "./DialogExibeReleaseNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports